import gql from 'graphql-tag';

export const QUERY_PROPERTY_DETAILS = gql`
    query property($propertyId: String!) {
        property(id: $propertyId) {
            uprn
            propertyId
        }
    }
`;
